var _defs, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgCameraIcon(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Group_10934",
    "data-name": "Group 10934",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 133,
    height: 106,
    viewBox: "0 0 133 106",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_3237",
    "data-name": "Rectangle 3237",
    width: 133,
    height: 106,
    transform: "translate(0 0)",
    fill: "none"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_10933",
    "data-name": "Group 10933",
    clipPath: "url(#clip-path)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_29484",
    "data-name": "Path 29484",
    d: "M7.5,5.208H20.75v8.718H7.5Zm77.292,8.833V8.521a5.521,5.521,0,1,1,11.042,0v5.521",
    transform: "translate(14.583 5.833)",
    fill: "#38668c"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_3235",
    "data-name": "Rectangle 3235",
    width: 26.5,
    height: 17.552,
    transform: "translate(53 2.208)",
    fill: "#ffca28"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_29485",
    "data-name": "Path 29485",
    d: "M9.583,6.75H120a8.814,8.814,0,0,1,8.833,8.833v66.25A8.807,8.807,0,0,1,120,90.667H9.583A8.814,8.814,0,0,1,.75,81.833V15.583A8.822,8.822,0,0,1,9.583,6.75",
    transform: "translate(1.458 13.125)",
    fill: "#e4eff8"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_29486",
    "data-name": "Path 29486",
    d: "M123.892,10.642v66.25a8.807,8.807,0,0,1-8.833,8.833H4.642a8.821,8.821,0,0,1-3.622-.783,8.778,8.778,0,0,0,8.038,5.2H119.475a8.807,8.807,0,0,0,8.833-8.833V15.058a8.778,8.778,0,0,0-5.2-8.038,8.821,8.821,0,0,1,.783,3.622",
    transform: "translate(1.983 13.65)",
    fill: "#c4dcf0"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_29487",
    "data-name": "Path 29487",
    d: "M40.5,55.458H.75V13.5H40.5",
    transform: "translate(1.458 26.25)",
    fill: "#ffca28"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_29488",
    "data-name": "Path 29488",
    d: "M18.227,13.5A32.994,32.994,0,0,0,16.41,55.458H23V13.5Z",
    transform: "translate(18.958 26.25)",
    fill: "#ecb200"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_29489",
    "data-name": "Path 29489",
    d: "M40.375,9.557H33.75v4.417H44.792V8.453a5.5,5.5,0,0,0-4.508-5.418,5.861,5.861,0,0,1,.091,1Z",
    transform: "translate(65.625 5.901)",
    fill: "#2c5170"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_29490",
    "data-name": "Path 29490",
    d: "M30.75,55.458H70.5V13.5H30.75",
    transform: "translate(59.792 26.25)",
    fill: "#ffca28"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_29491",
    "data-name": "Path 29491",
    d: "M77.5,42.875A33.125,33.125,0,1,1,44.375,9.75,33.118,33.118,0,0,1,77.5,42.875",
    transform: "translate(21.875 18.958)",
    fill: "#38668c"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_29492",
    "data-name": "Path 29492",
    d: "M60.362,12.32a33.1,33.1,0,0,1-46.51,46.7,33.1,33.1,0,1,0,46.51-46.7",
    transform: "translate(26.934 23.956)",
    fill: "#2c5170"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_29493",
    "data-name": "Path 29493",
    d: "M18,.75V18.3h4.417V5.167H44.5V.75Z",
    transform: "translate(35 1.458)",
    fill: "#ecb200"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_29494",
    "data-name": "Path 29494",
    d: "M16.333,3.75v4.3H7.5v4.417H20.75V3.75Z",
    transform: "translate(14.583 7.292)",
    fill: "#2c5170"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_29495",
    "data-name": "Path 29495",
    d: "M59.167,35.583A22.083,22.083,0,1,1,37.083,13.5,22.073,22.073,0,0,1,59.167,35.583",
    transform: "translate(29.167 26.25)",
    fill: "#e4eff8"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_29496",
    "data-name": "Path 29496",
    d: "M37.083,13.5a22.068,22.068,0,0,0-13.25,39.726A22.056,22.056,0,0,1,54.75,22.369,22.077,22.077,0,0,0,37.083,13.5",
    transform: "translate(29.167 26.25)",
    fill: "#c4dcf0"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_3236",
    "data-name": "Rectangle 3236",
    width: 4.417,
    height: 41.958,
    transform: "translate(125.875 39.75)",
    fill: "#ecb200"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_29497",
    "data-name": "Path 29497",
    d: "M50.792,2.208V17.655H37.542V11.042a2.194,2.194,0,0,0-2.22-2.2H22.1a.751.751,0,0,0-.23,0,2.2,2.2,0,0,0-1.99,2.2v6.613H11.042A11.048,11.048,0,0,0,0,28.708V94.97A11.021,11.021,0,0,0,11.042,106H121.47A11.026,11.026,0,0,0,132.5,94.97V28.708a11.031,11.031,0,0,0-11.03-11.053h-8.833v-3.3a7.741,7.741,0,0,0-15.482,0v3.3H81.708V2.208A2.222,2.222,0,0,0,79.512,0H52.782a2.219,2.219,0,0,0-1.99,2.208M55.22,4.417H77.292V17.564H55.22Zm6.613,8.845h8.845a2.209,2.209,0,0,0,0-4.417H61.833a2.208,2.208,0,0,0,0,4.417m43.074-2.22a3.291,3.291,0,0,1,3.313,3.313v3.3h-6.649v-3.3a3.311,3.311,0,0,1,3.336-3.312m-80.616,2.22h8.833v4.3H24.292Zm-13.25,8.81H121.47a6.612,6.612,0,0,1,6.613,6.637v8.845H91.923a35.327,35.327,0,0,0-51.333,0H4.417V28.708a6.615,6.615,0,0,1,6.625-6.637M66.25,30.917A30.917,30.917,0,1,1,35.322,61.845,30.924,30.924,0,0,1,66.25,30.917m0,6.637A24.286,24.286,0,1,0,90.542,61.845,24.284,24.284,0,0,0,66.25,37.553M4.417,41.97H37.023a35.254,35.254,0,0,0-1.357,37.542H4.417Zm61.833,0A19.869,19.869,0,1,1,46.375,61.845,19.852,19.852,0,0,1,66.25,41.97m29.215,0h32.619V79.512H96.846A35.391,35.391,0,0,0,95.465,41.97M79.476,59.59a2.207,2.207,0,0,0-2.185,2.255A11.028,11.028,0,0,1,66.25,72.875a2.208,2.208,0,1,0,0,4.417A15.444,15.444,0,0,0,81.708,61.845a2.21,2.21,0,0,0-2.232-2.255M4.417,83.917H38.669a35.343,35.343,0,0,0,55.173,0h34.241V94.97a6.6,6.6,0,0,1-6.613,6.613H11.042A6.615,6.615,0,0,1,4.417,94.97Z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCameraIcon);
export default __webpack_public_path__ + "static/media/camera_icon.28d058fcf1b8f411eef90fc03587067b.svg";
export { ForwardRef as ReactComponent };